/**
 * Yangi foydalanuvchini bir marta platforma tanishuviga yo'naltiradi.
 */
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthStore } from "@store/authStore";

const SKIP_PREFIXES = ["/onboarding", "/login", "/register", "/forgot-password", "/auth/"];

export function OnboardingGate() {
  const { isAuthenticated } = useAuthStore();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) return;
    if (SKIP_PREFIXES.some((p) => location.pathname.startsWith(p))) return;

    try {
      if (!localStorage.getItem("lifegram_onboarded")) {
        navigate("/onboarding", { replace: true });
      }
    } catch {
      /* ignore */
    }
  }, [isAuthenticated, location.pathname, navigate]);

  return null;
}
